import { isFacets } from './isFacets'

export function filteredInLinkWithFacets(href: string) {
  const hasFiltered = href?.indexOf('&filtered') !== -1

  if (href && isFacets(href) && !hasFiltered) {
    return `${href}&filtered`
  }

  return href
}
